export const HorizontalMarkSizeEnumsObj = {
  XS12: "XS_12",
  S16: "S_16",
  M28: "M_28",
} as const

export type HorizontalMarkSizeEnum = typeof HorizontalMarkSizeEnumsObj[keyof typeof HorizontalMarkSizeEnumsObj]
